import PropTypes from "prop-types";

import { TapestryCanvas } from "../vendor/liveTapRenderer";
// The pen-trace/seen-reveal keyframes CuratedText leans on.
import "../vendor/liveTapRenderer/styles/tapestryAnimations.css";

/**
 * What the scene and the board show before the planner's first version
 * (TT-1133, TT-1237): the classic canvas itself — symbol roles, slot fill,
 * dwell, the pen — on its paper skin, with its layout catalog off so it
 * stays generative (the picture is the planner's call, never the
 * catalog's). The host fades it out over the planned board (LiveHandoff).
 */
export default function ClassicOpening({ segments, currentSent, threshold, docTitle, docDate, resources, imageClient }) {
  return (
    <TapestryCanvas
      segments={segments}
      currentSent={currentSent}
      threshold={threshold}
      meetingName={docTitle}
      meetingDate={docDate}
      resources={resources}
      imageClient={imageClient}
      layouts={false}
      debugTools={false}
      fullscreenControl={false}
      skin="paper"
    />
  );
}

ClassicOpening.propTypes = {
  segments: PropTypes.array,
  currentSent: PropTypes.number,
  threshold: PropTypes.number,
  docTitle: PropTypes.string,
  docDate: PropTypes.string,
  resources: PropTypes.object,
  // the host's symbol image client (shared with its planned board)
  imageClient: PropTypes.object,
};
